import { useContext, useEffect } from 'react';
import ReviewSection from 'src/components/section/ReviewSection';
import AuthContext from 'src/store/auth-context';
import ReviewContext from 'src/store/review-page-context';
import SubmittersInfoComponent from 'src/components/SubmittersInfoComponent';
import shouldBypassItemization from 'src/util/shouldBypassItemization';

export default function ReviewPage() {
  const { reviewInfo, exemptionNotificationModal, needToItemizeModal } = useContext(ReviewContext);
  const { exemptionNotificationModalController, hasBeenDisplayed, setHasBeenDisplayed } =
    exemptionNotificationModal;
  const { needToItemizeModalController } = needToItemizeModal;
  const { review } = reviewInfo;
  const { account } = useContext(AuthContext);
  const displayExemptionNotificatoinModal =
    review.eligibleForExemption &&
    review?.updatedInfo?.reqExempt?.toUpperCase() !== 'Y' &&
    !hasBeenDisplayed;

  const forceItemize =
    review?.total?.count === 0 && !shouldBypassItemization(account, review.businessInfo);

  useEffect(() => {
    if (forceItemize) {
      needToItemizeModalController.openModal();
    }
    if (displayExemptionNotificatoinModal && !forceItemize) {
      exemptionNotificationModalController.openModal();
      setHasBeenDisplayed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [review]);

  return (
    <>
      <ReviewSection />
      <SubmittersInfoComponent />
    </>
  );
}
